module.exports = __webpack_public_path__ + "img/imagem4.8d53d592.jpg";